module.exports = __webpack_public_path__ + "static/media/brand-refresh-map-zoom-minus.e6ba626d.svg";